import type { Version } from "@angular/core";
import { InjectionToken } from "@angular/core";

export const APP_VERSION = new InjectionToken<Version>("version");
export const APP_SHA = new InjectionToken<string>("sha");
